# Behaviour for lesson panels display.
$(document).on 'turbo:load', ->
  if $('.panels').length
    new Panels()

class Panels
  constructor: ->
    @lessonsAll = new App.lessonsAll()
    @bindElements()
    @checkHashForPanelName()
    @gotoQuestion()

  checkHashForPanelName: ->
    $(window).load =>
      @activatePanel window.location.hash if window.location.hash

    window.addEventListener "hashchange", () =>
      @activatePanel window.location.hash if window.location.hash

  activatePanel: (hash) ->
    switch hash
      when "#discuss"
        $("a[data-panel='discussion']").click()
        if $('.discussHeader').hasClass('guided')
          $('.discussTab.guided a').click()
        else
          $('.discussTab.open a').click()
      when "#discussion-open"
        $("a[data-panel='discussion']").click()
        if $('.discussHeader').hasClass('guided')
          $('.discussTab.guided a').click()
        else
          $('.discussTab.open a').click()
      when "#watch"
        $("a[data-panel='watch']").click()
      when "#review"
        $("a[data-panel='review']").click()
      when "#digdeeper"
        $("a[data-panel='dig']").click()
      when "#finally"
        $("a[data-panel='final']").click()
      else
        if $(window).width() < 980
          $("a[data-panel]:not([data-panel='watch'])").first().click()


  changePanel: (e) ->
    ie9 = $('html').hasClass('ie9')
    e.preventDefault() if !ie9
    tab = $(e.target)

    @updateUrl(tab, ie9)
    @updatePanels(tab)

  updateUrl: (tab, ie9) ->
    if tab.data('url') && !ie9 && "#{tab.data('url')}" != "#{window.location.pathname}#{ window.location.hash}"
      History.pushState(null , null, "#{tab.data('url')}")

  onPanelSubtreeMod: () =>
    @activatePanel(window.location.hash) if window.location.hash

  updatePanels: (tab) =>
    # Hide All Tabs On Panel Change (This allows Think panel to be open by default if > 980 view is active)
    $('.panels .panel').addClass('hide')

    panelName = tab.data('panel')
    panelDiv = $('.panel.'+panelName)
    panelWrap = panelDiv.parents('.panels')

    if panelName is "watch"
      $('.uiToggleSwitch').removeClass('closed')
      $('.videoContainer').removeClass('isRight')
      panelWrap.addClass('closed')
    else
      @lessonsAll.logView()
      $('.uiToggleSwitch').addClass('closed')
      $('.videoContainer').addClass('isRight')
      panelWrap.removeClass('closed')

    if panelName is "review"
      unless panelDiv.hasClass("published")
        #rails-ujs requires native click event and not jQuery trigger event
        $(".openReviewBody").get(0).click()

    $('.panel.active').removeClass('active')
    $('.uiToggleSwitch .active').removeClass('active')

    tab.addClass('active')
    panelDiv.addClass('active')

  gotoQuestion: ->
    if window.location.hash.split('-')[0] == '#question'
      question = window.location.hash.split('-')[1]

      # highlight panel
      @updatePanels($('#think-link'))

      # go to question
      $(".carouselContainer.review").triggerHandler "slideToPage", question-1

      # update url
      url  = $(".panel.review").data('url') + '#question-' + question
      History.pushState(null , null, url)


  bindElements: ->
    $(document).on "click.uiToggle", ".uiToggleSwitch a", (e) =>
      @changePanel(e)
      $('textarea').blur()

    # Bind uiToggleSwitch Tooltips
    $(document).on "mouseenter.uiToggle", ".uiToggleSwitch li", (e) ->
      if !$('body').hasClass('mobile_tablet')
        $(this).find(".nav_tooltip").fadeIn(150).delay(1250).fadeOut(150)

    $(window).resize =>
      @activatePanel(window.location.hash)

    sideBar = document.getElementById("sideRail")
    observer = new MutationObserver(@onPanelSubtreeMod)
    observer.observe(sideBar, { attributes: false, childList: true, subtree: true })